import { style } from "@vanilla-extract/css";
import { vars } from "../../styles/theme.css";

export const squadStatusBarContainer = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: vars.radii.s,
  backgroundImage: `linear-gradient(to right, ${vars.colors.plBlue}, #6776ff)`,
  padding: `${vars.space["2xs"]} ${vars.space.m}`,
  color: vars.colors.primaryFixed,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.m,
  selectors: {
    '[dir="rtl"] &': {
      backgroundImage: `linear-gradient(to left, ${vars.colors.plBlue}, #6776ff)`,
    },
  },
});
